import { render, staticRenderFns } from "./IntegrityControlValidationsModal.vue?vue&type=template&id=5cc868ba&"
import script from "./IntegrityControlValidationsModal.vue?vue&type=script&lang=js&"
export * from "./IntegrityControlValidationsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports